import React, { useState } from "react";
//import PropTypes from 'prop-types';
import PageTitleUrl from "./PageTitleUrl";
import { usePageUrl } from "playground/cms/state/hooks";
import { useData } from "state/hooks";

export function PageTitleUrlContainer(props) {
    const {} = props;
    const url = usePageUrl(props.type, props.id);
    const { title } = useData(props);
    const [edit, setEdit] = useState(false);
    const open = () => window.open(`${url.host}/${url.slug}`);
    return (
        <PageTitleUrl
            {...props}
            {...url}
            title={title}
            edit={edit}
            onEdit={setEdit}
            onOpen={open}
        />
    );
}

PageTitleUrlContainer.propTypes = {};

PageTitleUrlContainer.defaultProps = {};

export default PageTitleUrlContainer;
